import { components } from "./components/index";
import { events } from "./events/index";

const OtherDocumentsSection = {
  events,
  components
};

export { OtherDocumentsSection }